/**
 * Shot list for the hidden /preview/photos page.
 * These photos finish the live homepage. Do not claim nut-friendly.
 */

export const PREVIEW_PHOTOS_PATH = '/preview/photos';

export const PREVIEW_PHOTOS_SEO = {
  title: "Preview photo list | Nanny B's Bakery",
  description:
    'Private shot list for Tammy. Phone photos for the live homepage. Not a public marketing page.',
  canonicalPath: PREVIEW_PHOTOS_PATH,
  robots: 'noindex, nofollow' as const,
  keywords: 'Nanny B bakery preview photos',
};

/**
 * Must-have shots. Keep this short so Tammy can finish in one quiet moment.
 * Do not ask for churros — that was an old stock image in the repo, not a confirmed menu item.
 * Stuffed cookies are on the live menu. Decorating can be Tammy or her chef/helper.
 */
export const PREVIEW_MUST_HAVE_SHOTS = [
  {
    title: 'You at the counter or in the kitchen',
    detail:
      'Waist-up, smiling, face clear. Shop lights on. This is the Meet Tammy photo.',
  },
  {
    title: 'Someone decorating a cake (you or your chef)',
    detail:
      'Whoever usually pipes or finishes cakes. Piping, spreading frosting, or placing toppers. Hands and face if possible.',
  },
  {
    title: 'Inside the shop from the customer side',
    detail: 'Display case, counter, and the room as a customer sees it. Lights on.',
  },
  {
    title: 'Fresh stuffed cookies (or another case treat) on a tray',
    detail:
      'Something you actually bake that day — stuffed cookies, butter tarts, etc. Close enough to see detail. Walk closer. Do not zoom.',
  },
  {
    title: 'One custom cake on the shop counter',
    detail: 'A real cake in the bakery, not a screenshot of an old photo.',
  },
] as const;

export const PREVIEW_OPTIONAL_SHOTS = [
  {
    title: 'One regular helper who says yes',
    detail:
      'First name only on the website. Skip anyone under 18 unless a parent says yes.',
  },
  {
    title: 'Hands packing or handing a box',
    detail: 'No customer faces unless that person said yes.',
  },
  {
    title: 'A short phone video (optional)',
    detail:
      '10–20 seconds of decorating or packing treats. Only if it is easy. No need to film if you are busy.',
  },
] as const;
